import { createFileRoute } from "@tanstack/react-router";

import { BlogCategoryPage, categoryHead } from "../components/blog/BlogCategoryPage";

export const Route = createFileRoute("/blog/video-content")({
  head: () => categoryHead("videoContent", 1),
  component: CategoryRoute,
});

function CategoryRoute() {
  return <BlogCategoryPage categoryKey="videoContent" page={1} />;
}
